// frontend/src/services/conciliacaoBancaria.api.js
import axios from '@/services/axios'

export function listarImportacoes(params = {}) {
  return axios.get('/financeiro/conciliacao/importacoes', { params })
}

export function detalharImportacao(id) {
  return axios.get(`/financeiro/conciliacao/importacoes/${id}`)
}

export function importarOfx(formData) {
  return axios.post('/financeiro/conciliacao/importacoes/ofx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function importarOperadora(formData) {
  return axios.post('/financeiro/conciliacao/importacoes/operadora', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}


export function vincularIdentidadeOfx(formData) {
  return axios.post(
    '/financeiro/conciliacao/identidades/ofx/vincular',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  )
}

export function vincularIdentidadeOperadora(formData) {
  return axios.post(
    '/financeiro/conciliacao/identidades/operadora/vincular',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  )
}

export function obterResumo(params = {}) {
  return axios.get('/financeiro/conciliacao/resumo', { params })
}

export function listarBanco(params = {}) {
  return axios.get('/financeiro/conciliacao/banco', { params })
}

export function listarMovimentacoes(params = {}) {
  return axios.get('/financeiro/conciliacao/movimentacoes', { params })
}

export function listarOperadora(params = {}) {
  return axios.get('/financeiro/conciliacao/operadora', { params })
}

export function listarChargebacks(params = {}) {
  return axios.get('/financeiro/conciliacao/chargebacks', { params })
}

export function listarCandidatos(params = {}) {
  return axios.get('/financeiro/conciliacao/candidatos', { params })
}

export function conciliarManual(payload) {
  return axios.post('/financeiro/conciliacao/conciliar-manual', payload)
}

export function desfazerConciliacao(payload) {
  return axios.post('/financeiro/conciliacao/desfazer', payload)
}

export function desfazerBancoOperadoraConciliacao(payload) {
  return axios.post('/financeiro/conciliacao/banco-operadora/desfazer', payload)
}

export function listarCandidatosBancoOperadora(params = {}) {
  return axios.get('/financeiro/conciliacao/banco-operadora/candidatos', { params })
}

export function conciliarManualBancoOperadora(payload) {
  return axios.post('/financeiro/conciliacao/banco-operadora/conciliar-manual', payload)
}

export function reprocessarAutomaticoBancoOperadora(payload) {
  return axios.post('/financeiro/conciliacao/banco-operadora/reprocessar-automatico', payload)
}

export function detalharConciliacao(params = {}) {
  return axios.get('/financeiro/conciliacao/detalhar', { params })
}

export function detalharBancoOperadoraConciliacao(params = {}) {
  return axios.get('/financeiro/conciliacao/banco-operadora/detalhar', { params })
}

export function tratarChargeback(payload) {
  return axios.post('/financeiro/conciliacao/chargebacks/tratar', payload)
}

export function regularizarVendaCanceladaLiquidada(payload) {
  return axios.post(
    '/financeiro/conciliacao/operadora/regularizar-venda-cancelada',
    payload
  )
}

export function conciliarConsolidado(payload) {
  return axios.post('/financeiro/conciliacao/conciliar-consolidado', payload)
}

export function conciliarComAjuste(payload) {
  return axios.post('/financeiro/conciliacao/conciliar-com-ajuste', payload)
}

export function criarReceitaEConciliar(payload) {
  return axios.post('/financeiro/conciliacao/criar-receita-e-conciliar', payload)
}

export function criarDespesaEConciliar(payload) {
  return axios.post('/financeiro/conciliacao/criar-despesa-e-conciliar', payload)
}

export function listarCandidatosConciliacaoComposta(params = {}) {
  return axios.get('/financeiro/conciliacao/composta/candidatos', { params })
}

export function confirmarConciliacaoComposta(payload) {
  return axios.post('/financeiro/conciliacao/composta/confirmar', payload)
}

export function ajustarPagamentosEConfirmarComposta(payload) {
  return axios.post('/financeiro/conciliacao/composta/ajustar-pagamentos-e-confirmar', payload)
}

export function criarReceitaAbatimentoEConfirmarComposta(payload) {
  return axios.post('/financeiro/conciliacao/composta/criar-receita-abatimento-e-confirmar', payload)
}

